import _objectSpread from "@babel/runtime/helpers/objectSpread";
import qs from 'query-string';
/**
 * Хэлпер для создания строки URL адреса
 * @param   {String} url            Путь
 * @param   {Object} query          Объект параметров запроса
 * @example
 * createPath('/library', { id: 1 })  // => /library?id=1
 * @returns {String}                Итоговый путь
 */

export function createPath(u, query) {
  var url = u;
  var hashExist = url.includes('#');
  var hash = hashExist ? url.split('#')[1] : '';

  if (hashExist) {
    url = url.replace('#', '');
    url = url.replace(hash, '');
  }

  var _url$split = url.split('?'),
      urlPath = _url$split[0],
      urlQuery = _url$split[1];

  var queryParams = qs.stringify(_objectSpread({}, qs.parse(urlQuery), query), {
    encode: false
  });
  return [urlPath, queryParams].filter(function (s) {
    return !!s;
  }).join('?') + (hashExist ? "#" + hash : '');
}
/**
 * Хэлпер для того чтобы парсить строку запроса (location.search)
 * @param  {String} query Строка запроса
 * @return {Object}       Объект содержащий параметры запроса
 * @example
 * parseQueryString('/library?id=1')  // => { id: 1 }
 */

export function parseQueryString(query) {
  return qs.parse(query);
}
/**
 * Функция извлекает URL следующей страницы из HTTP заголовка Link
 *
 * @param  {String} link Содержимое заголовка Link
 * @return {String}      URL адрес следующей страницы или пустая строка
 *
 * @example
 *   var link = "<http://localhost:3500/api/library/pupil_courses?page=2>; rel='next'"
 *   var url = getNextPageURLFromLinkHeader(link)
 *   url === 'http://localhost:3500/api/library/pupil_courses?page=2'
 */

export function getNextPageURLFromLinkHeader(link) {
  if (link === void 0) {
    link = '';
  }

  var result = link.match(/<([^>]+)>/);
  return result ? result[1] : '';
}
/**
 * Функция извлекает номер следующей страницы из HTTP заголовка Link
 *
 * @param  {String} link Содержимое заголовка Link
 * @return {Number} page номер страницы или null
 *
 * @example
 *   var link = "<http://localhost:3500/api/library/pupil_courses?page=2>; rel='next'"
 *   var url = getNextPageURLFromLinkHeader(link)
 *   url === 'http://localhost:3500/api/library/pupil_courses?page=2'
 */

export function getNextPageFromLinkHeader(link) {
  if (link === void 0) {
    link = '';
  }

  return link ? parseInt(/[?&]page=([^&>]+)[&>]/gi.exec(link)[1]) || null : null;
}
/**
 * Generate url param string
 *
 * @export
 * @param {object} object
 * @returns {string}
 */

export function makeParamString(object) {
  if (object === void 0) {
    object = {};
  }

  return Object.keys(object).map(function (key) {
    return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
  }).join('&');
}